module.exports = __webpack_public_path__ + "img/set.f4acf1f9.svg";